import { useEffect } from 'react'
import moment from 'moment'
import RadioGroup from '../../../components/RadioGroup/RadioGroup'
import { Datepicker } from '../../../components/Datepicker'
import { Typography } from '../../../components/Typography'
import { AdminTable } from './AdminTable/AdminTable'
import { FinancialsChartLegendPart } from '../FinancialsChartLegendPart/FinancialsChartLegendPart'
import { PaymentStatusChart } from '../PaymentStatusChart/PaymentStatusChart'
import { useFinancialsAdminContext } from '../Providers/FinancialsAdminProvider'
import { useFinancialsAbility } from '../Providers/FinancialsAbilityProvider'
import { getFinancialStatusLegendOrder } from '../FinancialsChartLegendPart/constants'
import { FINANCIAL_STATUS_LABEL, REPORTS_COLORS } from '../constants'
import { timelineYearFormat } from '../../../components/Timelines/constants'
import { ADMIN_TABS } from './constants'
import { ACTIONS, SUBJECTS } from '../Abilities'
import { ReactComponent as ArrowRight16 } from 'assets/svg/ArrowRight16.svg'
import { ReactComponent as ArrowLeft16 } from 'assets/svg/ArrowBack16.svg'

export const Admin = () => {
  const ability = useFinancialsAbility()
  const {
    state: { period, reports, totalAmount, activeTab },
    actions: { setPeriod, getChartsData, onChangeTab }
  } = useFinancialsAdminContext()

  useEffect(() => {
    if (period && activeTab) {
      void getChartsData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [period, activeTab])

  return (
    <div className="rebates column gap-24">
      {ability.can(ACTIONS.VIEW, SUBJECTS.ADMIN_SUBTABS) && activeTab && (
        <RadioGroup.Buttons
          options={ADMIN_TABS}
          defaultValue={activeTab}
          onChange={onChangeTab}
        />
      )}
      <div className="rebates__date-filter">
        <Datepicker
          propsDate={{
            format: timelineYearFormat,
            value: period,
            onChange: (date) => setPeriod(moment(date).startOf('year')),
            picker: 'year',
            superNextIcon: <ArrowRight16 />,
            superPrevIcon: <ArrowLeft16 />
          }}
          propsItem={{
            label: 'Period'
          }}
        />
      </div>
      <div className="rebates__container column gap-24">
        <Typography.Headline4>Payment Status</Typography.Headline4>
        <div className="rebates__chart-container row">
          <div className="rebates__chart">
            <PaymentStatusChart
              total={totalAmount}
              data={getFinancialStatusLegendOrder(reports)}
              needMultiply
            />
          </div>
          <div className="rebates__legend">
            {getFinancialStatusLegendOrder(reports).map((i) => (
              <FinancialsChartLegendPart
                key={i.status}
                color={REPORTS_COLORS[i.status]}
                name={FINANCIAL_STATUS_LABEL[i.status]}
                price={i.amount}
              />
            ))}
          </div>
        </div>
      </div>
      <AdminTable />
    </div>
  )
}
